import Vue from "vue"
import type { RawLocation, Route } from "vue-router"
import Router from "vue-router"

class Navigation {
	public install(vue: typeof Vue, options: any): void {
		vue.prototype.$navigateTo = function(this: Vue, location: RawLocation, replace: boolean = false) {
			return (replace ? this.$router.replace(location) : this.$router.push(location))
				.catch(reason => {
					if (!(Router.isNavigationFailure(reason, Router.NavigationFailureType.redirected) || Router.isNavigationFailure(reason, Router.NavigationFailureType.duplicated)))
						throw reason
				})
		}
		vue.prototype.$replaceQuery = function(this: Vue, parameters: Record<string, any>) {
			const existing = this.$route.query

			return this.$navigateTo({path: this.$route.path, query: {...existing, ...parameters}}, true)
		}
	}
}

Vue.use(new Navigation())

declare module "vue/types/vue" {
	// tslint:disable:interface-name
	interface Vue {
		$navigateTo(location: RawLocation, replace?: boolean): Promise<Route | void>
		$replaceQuery(parameters: Record<string, any>): Promise<Route | void>
	}
}
